
// Copyright (c) 2021 Davide Gironi
// Please refer to LICENSE file for licensing information.

import React from 'react';
import PropTypes from 'prop-types';

export default function DefaultPageTitle({ children }) {
    return (
        <div className="default-page-title">
            {children}
        </div>
    );
}

DefaultPageTitle.propTypes = {
    children: PropTypes.node
};
DefaultPageTitle.defaultProps = {
    children: null
};